<template>
     <el-dialog
     :title="title"
     :visible.sync="dialogVisible"
     width="45%"
    :show-close="true"
    :modal-append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    :destroy-on-close="true"
    @close="closeDialog"
    >
       <div class="panel">
           <el-form ref="form" :model="form" :rules="formRules" label-width="110px">
                <el-row :gutter="5">
                    <el-col :span="12">
                        <el-form-item label="产品编号">
                            <el-input size="small" v-model="form.productCode" placeholder="输入产品编号，忽略将自动生成" :readonly="mode != 'create'" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="产品名称" prop="productName">
                            <el-input size="small" v-model="form.productName" placeholder="请输入" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="库存单位" prop="unit">
                          <el-select
                            size="small"
                            v-model="form.unit"
                            clearable
                            placeholder="请选择"
                            style="width:100%;"
                          >
                            <el-option
                              v-for="item in unitList"
                              :key="item.unitName"
                              :label="item.unitName"
                              :value="item.unitName"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="产品规格" prop="specs">
                            <el-input size="small" v-model="form.specs" placeholder="输入产品规格" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="产品属性" prop="source">
                            <el-select
                            size="small"
                            v-model="form.source"
                            clearable
                            placeholder="请选择"
                            style="width:100%;"
                          >
                            <el-option
                              v-for="item in sourceList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工艺路线" prop="technologyCode">
                          <el-select
                          size="small"
                            v-model="form.technologyCode"
                            clearable
                            placeholder="请选择"
                            style="width:100%;"
                          >
                            <el-option
                              v-for="item in technologyList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="最大库存" prop="maxStock">
                            <el-input-number v-model="form.maxStock" controls-position="right" size="small"  :min="1" :max="9007199254740991" style="width:100%" ></el-input-number>
                        </el-form-item>
                    </el-col>
                     <el-col :span="12">
                        <el-form-item label="最小库存" prop="minStock">
                          <el-input-number v-model="form.minStock" controls-position="right" size="small"  :min="1" :max="9007199254740991" style="width:100%" ></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="安全库存" prop="safeStock">
                          <el-input-number v-model="form.safeStock" controls-position="right" size="small"  :min="1" :max="9007199254740991" style="width:100%" ></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <FormItem :setList="setList" :form="form" :mode="mode" v-if="showChild"></FormItem>
           </el-form>


       </div>
       <div class="panel-bottom">
            <el-button size="small" type="default"  @click="closeDialog">取消</el-button>
            <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
        </div>

    </el-dialog>
</template>
<script>
import { technologyGetAll,productSave,unitGetAll} from '@/api/basicData';
import FormItem from "@/components/FormItem";
export default {
    name:'createProduct',
    components:{FormItem},
    props:{
        diaVisible:{
            type:Boolean,
            default:false,
        },
        userData:{
            type:Object,
            default:{},
        },
        editRow:{
          type:Object,
          default:{},
        },
        mode:{
          type:String,
          default:''
        },
        setList:{
            type:Array,
            default:[],
        }
    },
    watch:{
        diaVisible(newVal,oldVal){
            this.showChild = true;
            if(newVal){
                this.dialogVisible = newVal;
                if(this.mode == 'edit'){
                  this.title = '修改产品';
                  this.form =JSON.parse(JSON.stringify(this.editRow))
                }
                if(this.mode == 'create'){
                  this.title = '创建产品';
                  this.form = {
                    stockNum:0,
                  }
                }
            }
        }
    },
    data(){
        return{
            dialogVisible: false,
            form:{
              stockNum:0,
            },
            formRules:{
              productName: [{
                  required: true,
                  message: "请输入产品名称",
                  trigger: "blur",
              },] ,
              unit: [{
                  required: true,
                  message: "请选择库存单位",
                  trigger: "blur",
              },] ,
              source: [{
                  required: true,
                  message: "请选择产品属性",
                  trigger: "blur",
              },] ,
              technologyCode: [{
                  required: true,
                  message: "请选择工艺路线",
                  trigger: "change",
              },] ,
            },
            technologyList:[],
            sourceList:[{
              label:'自制',
              value:'自制'
            },{
              label:'外购',
              value:'外购'
            },{
              label:'委外',
              value:'委外'
            }],
            unitList:[],
            imageUrl:'',
            title:'创建产品',
            showChild:true
        }
    },
    created(){
      this.unitGetAll()
      this.getTechnologyList()
    },

    methods:{
       // 查询所有单位
      unitGetAll(){
        unitGetAll(this.userData.factoryId).then(res => {
          if(res.code == 200){
            this.unitList = res.data;
          }
        })
      },
      handleSave(){
        this.$refs.form.validate((valid) => {
          if (valid) {
            var data = JSON.parse(JSON.stringify(this.form))
            data.factoryId = this.userData.factoryId
            data.updater = this.userData.name + '(' + this.userData.account + ')';
            if(this.mode == 'create'){
              data.creater = this.userData.name + '(' + this.userData.account + ')';

            }


            productSave(data).then(res => {
              if(res.code == 200){
                this.$message.success('保存成功')
              }else{
                this.$message.error(res.msg)
              }
              this.showChild = false;
              this.dialogVisible = false;
              this.$emit('save',{type:'save'});
              this.loading = false
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err)
            })
          }
        })
      },

      closeDialog(){
          setTimeout(() => {
              this.showChild = false;
              this.dialogVisible = false;
              this.$parent.createProductPanVisible = false;
          }, 100);
      },
      getTechnologyList(){
        technologyGetAll(this.userData.factoryId).then(res => {
          if(res.code == 200){
            this.technologyList = res.data.map(item=>{
              return {
                label:item['technologyName'],
                value:item['technologyCode'],
              }
            })
          }else{
            this.$message.error('查询失败！')
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err)
        })
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
    }

}
</script>
<style scoped>
    .panel{
        max-height: 45vh;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .panel-bottom{
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding-top: 20px;
        text-align: center;
    }
    .panel-bottom el-button{
        margin: 10px 0 0 10px;
    }


</style>



// WEBPACK FOOTER //
// src/views/basicData/productDefinition/createProduct.vue